import React from 'react';

/**
 * DashboardViewTabs - Toggle between "My Ideas" and "Received" views
 * Similar to the Feed/Sources toggle but for idea ownership
 */
const DashboardViewTabs = ({ 
  ideaView, 
  setIdeaView, 
  myIdeasCount, 
  receivedCount 
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setIdeaView('my')}
        data-testid="my-ideas-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          ideaView === 'my' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        My Ideas
        {myIdeasCount > 0 && (
          <span className={`ml-1.5 ${ideaView === 'my' ? 'text-slate-500' : 'text-white/50'}`}>
            ({myIdeasCount})
          </span>
        )}
      </button>
      <button
        onClick={() => setIdeaView('received')}
        data-testid="received-ideas-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          ideaView === 'received' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Received
        {receivedCount > 0 && (
          <span className={`ml-1.5 ${ideaView === 'received' ? 'text-slate-500' : 'text-white/50'}`}>
            ({receivedCount})
          </span>
        )}
      </button>
    </div>
  );
};

export default DashboardViewTabs;
